module.exports = {
  "id": "basket",
  "title": "basket",
  "image": "provision/parts/basket/basket.png",
  "info": [
    {
      "text": "Add a basket to your project",
      "image": "provision/parts/basket/basket.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/basket/basket.png"
} ;